import { render } from "./AsahiSelectHeader.vue?vue&type=template&id=54c3a139&scoped=true&ts=true"
import script from "./AsahiSelectHeader.vue?vue&type=script&lang=ts"
export * from "./AsahiSelectHeader.vue?vue&type=script&lang=ts"

import "./AsahiSelectHeader.vue?vue&type=style&index=0&id=54c3a139&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c3a139"]])

export default __exports__